export default __webpack_public_path__ + "static/media/Path_1432.c7d12a58.svg";